<template>
  {{#if @mlp.isV2}}
    <@form.fieldset
      @titleKey='customOptions'
      @isClosed={{true}}
      @showSelectedAttributesIndicator={{true}}
      as |fieldset|
    >
      <fieldset.field
        @property='options.customOptions'
        @type='code-editor'
        @codeFormat='json'
      />
    </@form.fieldset>
  {{/if}}
</template>
